import { Button } from '@askable/ui/core/button';
import { MessageCircleWarningIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'src/lib/routing';

import { ErrorPage } from 'components/ErrorPage/ErrorPage';

export const ViewerErrorPage = ({ onRetry }: { onRetry: () => void }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ErrorPage className="text md:max-w-[540px]">
      <MessageCircleWarningIcon className="h-8 w-8" aria-hidden />
      <h1 className="text-lg font-medium text-foreground">{t('sections.errorBoundary.default')}</h1>
      <div className="flex gap-2">
        <Button variant="primary" onClick={onRetry}>
          {t('global.tryAgain')}
        </Button>
        <Button variant="outline" onClick={() => navigate('/logout')}>
          {t('global.signOut')}
        </Button>
      </div>
    </ErrorPage>
  );
};
